export class GetCitiesRequest{
    //userid: string|number = 0;
    //countrycode: string ='US';
    //language: string = 'EN';
    LOB: string = 'OL';
    postalcode: string|number = 0;
}